module.exports = __webpack_public_path__ + "static/media/background-desktop.b51ef243.png";